import { Box, Text } from "flicket-ui";
import NextImage from "next/future/image";
import { ExtendedFile } from "~graphql/sdk";
import { getImageSrc } from "~lib";
import React from "react";
import styled from "styled-components";

const ImageContainer = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.colors.N100};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
`;

export interface EventImageProps {
  eventImage: ExtendedFile | null | undefined;
  title: string | null | undefined;
  style?: React.CSSProperties;
}

/**
 * Component for displaying an event image with fallback
 *
 * @param props - Component props
 * @param props.eventImage - The image file to display
 * @param props.title - Image alt text and fallback message
 * @param props.style - Optional styles to apply to the container
 */
export const EventImage: React.FC<EventImageProps> = ({
  eventImage,
  title,
  style = {},
}) => (
  <ImageContainer style={style}>
    {eventImage ? (
      <Box
        position="relative"
        width="100%"
        height="100%"
        borderRadius="md"
        overflow="hidden"
      >
        <NextImage
          src={getImageSrc(eventImage) || ""}
          alt={title || "Event image"}
          fill
          style={{
            objectFit: "cover",
            objectPosition: "center",
          }}
          priority
        />
      </Box>
    ) : (
      <Text variant="regular" color="N500">
        No event banner
      </Text>
    )}
  </ImageContainer>
);
